import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, Copy, Check } from "lucide-react";
import { useAds } from "@/store/ads";

const KEY = "bb_welcome_popup_v1";

export default function WelcomePopup() {
  const { adMode } = useAds();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (adMode) return; // paid traffic — never block conversion
    if (localStorage.getItem(KEY)) return;
    const t = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(t);
  }, [adMode]);

  const dismiss = () => {
    localStorage.setItem(KEY, "seen");
    setOpen(false);
  };

  const copy = () => {
    navigator.clipboard.writeText("WELCOME10").catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] bg-black/70 backdrop-blur-sm flex items-center justify-center px-6"
          data-testid="welcome-popup"
          onClick={dismiss}
        >
          <motion.div
            initial={{ y: 30, opacity: 0, scale: 0.95 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 20, opacity: 0, scale: 0.95 }}
            transition={{ type: "spring", damping: 26, stiffness: 260 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-lg rounded-2xl border border-[#FF3D8B]/40 bg-[#0a0a0a] p-10 shadow-[0_0_80px_rgba(255,61,139,0.4)]"
          >
            <button
              onClick={dismiss}
              data-testid="welcome-popup-close"
              className="absolute top-4 right-4 text-white/50 hover:text-white"
            >
              <X size={20} />
            </button>
            <div className="text-[#A855F7] uppercase text-xs tracking-widest mb-2">
              First time here?
            </div>
            <h2 className="font-display text-5xl text-white leading-none">
              Take <span className="text-neon-pink">10% off.</span>
            </h2>
            <p className="text-white/70 mt-4 text-sm leading-relaxed">
              Welcome to Booty Breeze. Use this code at checkout — it's on the house.
            </p>
            <button
              onClick={copy}
              data-testid="welcome-popup-copy"
              className="mt-6 w-full flex items-center justify-between px-5 py-4 rounded-lg border-2 border-dashed border-[#FF3D8B] bg-[#FF3D8B]/10 hover:bg-[#FF3D8B]/20 transition-colors"
            >
              <span className="font-display text-2xl text-[#FF3D8B]">WELCOME10</span>
              <span className="inline-flex items-center gap-2 text-white/70 text-xs uppercase tracking-widest">
                {copied ? <><Check size={14} /> Copied</> : <><Copy size={14} /> Tap to copy</>}
              </span>
            </button>
            <button
              onClick={dismiss}
              className="mt-5 w-full py-3 rounded-full bg-[#FF3D8B] text-black font-bold uppercase tracking-widest text-xs hover:bg-[#ff5ba0] transition-colors"
              data-testid="welcome-popup-cta"
            >
              Start Shopping
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
